import { Grid } from "@syncfusion/ej2/grids";
import { ConstantVariables } from "./ConstantVariables";
import { DropDownList } from "@syncfusion/ej2/dropdowns";

export class SyncfusionDropdownHelper {
    public static templateEnumOptionsDropDown(getWorkbookGrid: () => Grid | undefined, 
        column:string, options:any[], changeCallback: (args: any) => void, defaultValue : string | undefined = undefined) {

        var self = this;
        let dropdown: HTMLSelectElement;
        let dropdownList: DropDownList;

        const getPersistedFilterValue = (): string | undefined => {
            const workbookGrid = getWorkbookGrid();

            const filterColumn = workbookGrid?.filterSettings?.columns
                ?.find((x: any) => x.field === column);

            return filterColumn?.value?.toString();
        };

        const dropdownOptions = {
            create: () => {
                dropdown = document.createElement('select');
                dropdown.id = column;

                const allOption = document.createElement('option');
                allOption.value = 'All';
                allOption.innerText = '<All>';
                dropdown.appendChild(allOption);

                options.forEach((item) => {
                    const option = document.createElement('option');
                    option.value = item?.toString();
                    option.innerText = item?.toString();
                    dropdown.appendChild(option);
                });

                return dropdown;
            },

            write: (args: any) => {
                const persistedValue =
                    args?.value?.toString()
                    ?? getPersistedFilterValue()
                    ?? defaultValue
                    ?? 'All';

                dropdownList = new DropDownList({
                    value: persistedValue,
                    change: (args) => {
                        changeCallback(args);
                    }
                });

                dropdownList.appendTo(dropdown);
            }
        };

        return dropdownOptions;
    }
}